module.exports = __webpack_public_path__ + "static/media/featured-2-bed-en.0a7c250c.png";